import React, { useState } from 'react';

/**
 * Search + canal/cliente filters for the stores list. Every change writes the filtered list
 * back through `setRows`, exactly as before.
 */
export function useTableActions({ setRows, storesData }) {
    const [suggestions, setSuggestions] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [channel, setChannel] = React.useState('both');
    const [client, setClient] = React.useState('both');

    const onSearch = (search) => {
        try {
            setSearchValue(search);
            if (!search || typeof search !== 'string') {
                setSuggestions([]);
                setRows(storesData);
                return;
            }

            const filteredData = storesData.filter((c) => c.name && c.name.toLowerCase().includes(search.toLowerCase()));
            setRows(filteredData);
            setSuggestions(filteredData.map((c) => c.name));
        } catch (error) {
            console.warn('Error in store search:', error);
            setSuggestions([]);
        }
    };

    const onChangeChannel = (value) => {
        setChannel(value);
    };

    const onChangeClient = (value) => {
        setClient(value);
    };

    React.useEffect(() => {
        let filteredData = storesData;
        if (channel !== 'both') {
            filteredData = filteredData.filter((c) => c.channel === channel.toUpperCase());
        }
        if (client !== 'both') {
            filteredData = filteredData.filter((c) => c.clientName === client);
        }

        setRows(filteredData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channel, client]);

    const clients = Array.from(new Set(storesData?.map((client) => client.clientName))).filter((store) => store !== '');

    const hasActiveFilters = channel !== 'both' || client !== 'both' || searchValue;

    const clearFilters = () => {
        setChannel('both');
        setClient('both');
        setSearchValue('');
        setRows(storesData);
    };

    return {
        suggestions,
        searchValue,
        setSearchValue,
        channel,
        client,
        clients,
        hasActiveFilters,
        onSearch,
        onChangeChannel,
        onChangeClient,
        clearFilters
    };
}
